import { render, staticRenderFns } from "./CryptoAssetDetails.vue?vue&type=template&id=dcc44286&scoped=true"
import script from "./CryptoAssetDetails.vue?vue&type=script&lang=js"
export * from "./CryptoAssetDetails.vue?vue&type=script&lang=js"
import style0 from "./CryptoAssetDetails.vue?vue&type=style&index=0&id=dcc44286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc44286",
  null
  
)

export default component.exports